import http from "@/plugins/http";

export const state = {
  available: {},
  details: {},
  status: {},
  serviceAccount: {},
  ipGroups: [],
  serviceDetails: {},
  rateplans: []
};

export const getters = {
  available: state => {
    return state.available;
  },
  details: state => {
    return state.details;
  },
  status: state => {
    return state.status;
  },
  serviceAccount: state => {
    return state.serviceAccount;
  },
  ipGroups: state => {
    return state.ipGroups;
  },
  serviceDetails: state => {
    return state.serviceDetails;
  },
  rateplans: state => {
    return state.rateplans;
  }
};

export const mutations = {
  SET_AVAILABLE(state, data) {
    state.available = data;
  },
  SET_DETAILS(state, data) {
    state.details = data;
  },
  SET_SERVICE_ACCOUNT(state, data) {
    state.serviceAccount = data;
  },
  SET_STATUS(state, data) {
    state.status = data;
  },
  SET_IP_GROUP(state, data) {
    state.ipGroups = JSON.parse(data.staticIps);
  },
  SET_IP(state, data) {
    state.details.radiusStaticIp = data;
  },
  SET_SERVICE_DETAILS(state, data) {
    state.serviceDetails = {
      siteContactName: data.serviceName,
      serviceStreet: data.serviceAddress,
      userService: data.userService
    };
  },
  SET_RADIUS_ACCOUNT(state, data) {
    state.details.radiusAccountId = data;
  },
  SET_RATEPLANS(state, data) {
    state.rateplans = data;
  }
};

export const actions = {
  setAvailableService({ commit }, payload) {
    commit("SET_AVAILABLE", payload);
    commit("SET_SERVICE_DETAILS", payload);
  },
  resetAvailableService({ commit }) {
    commit("SET_AVAILABLE", {});
    commit("SET_DETAILS", {});
  },
  setDetails({ commit }, data) {
    commit("SET_DETAILS", data);
  },

  async reactivateService({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });

    try {
      let service = await http.post(
        `visp/ReactivateService/${payload.radiusServiceId}`
      );

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(service.data.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  async removeService({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });

    try {
      let service = await http.post(
        `visp/RemoveService/${payload.radiusServiceId}`
      );

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(service.data.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async suspendService({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });

    try {
      let service = await http.post(`visp/SuspendService`, payload);

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      dispatch(
        "httpResponse/setHttpResponse",
        { text: "Successfully suspended the service", color: "" },
        { root: true }
      );
      return Promise.resolve(service.data.data);
    } catch (e) {
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  async resumeService({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let service = await http.post(`visp/ResumeService`, payload);

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      dispatch(
        "httpResponse/setHttpResponse",
        { text: "Successfully resumed the service", color: "" },
        { root: true }
      );
      return Promise.resolve(service.data.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.response.data, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  createEmptyService({ commit }) {
    commit("SET_DETAILS", {
      accountNumber: 0,
      billingId: 0,
      id: 0,
      isRadiusActive: "y",
      kayakoConversation: null,
      lineStatus: null,
      masterServiceId: 0,
      radiusAccountId: 0,
      radiusGarden: null,
      radiusPassword: null,
      radiusServiceId: 0,
      radiusShape: null,
      radiusStaticIp: null,
      radiusUsername: null,
      supplierBillingReference: null,
      ratePlanId: null,
      serviceId: null
    });
  },

  async getNbnServices({ commit, dispatch }, search) {
    try {
      let services = await http.post(`visp/GetServicesAll`, search);
      if (services && services.data && services.data.data) {
        commit("search/SET_SERVICES", services.data.data, {
          root: true
        });
        return Promise.resolve(services.data.data);
      }
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getMasterServices({ dispatch }, search) {
    try {
      let services = await http.post(`visp/GetMasterServices`, search);
      if (services && services.data) {
        return Promise.resolve(services.data);
      }
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setRadiusAccount({ commit }, val) {
    commit("SET_RADIUS_ACCOUNT", val);
  },
  async getRadiusAccounts({ dispatch }) {
    try {
      let services = await http.get(`visp/GetRadiusAccounts`);
      if (services && services.data) {
        return Promise.resolve(services.data);
      }
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  async getFeatures({ dispatch }) {
    try {
      let features = await http.get(`visp/GetFeatures/`);
      if (features && features.data) {
        return Promise.resolve(features.data.data);
      }
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  async getWholesalerFeatureByWholesalerId({ dispatch }, wholesalerId) {
    try {
      let wholesalerFeatures = await http.get(
        `visp/GetWholesalerFeatureByWholesalerId/${wholesalerId}`
      );
      if (wholesalerFeatures && wholesalerFeatures.data) {
        return Promise.resolve(wholesalerFeatures.data.data);
      }
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  async getService({ state, commit, dispatch }, radiusServiceId) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let details = await http.get(
        `visp/GetServiceById/${radiusServiceId ||
          state.available.radiusServiceId}`
      );
      commit("SET_DETAILS", details.data.data);
      dispatch("getStatus", radiusServiceId || state.available.radiusServiceId);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(details.data.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getUsage({ commit, dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let usage = await http.post(`visp/GetUsageSummary`, payload);
      let data =
        usage.data.data.length !== 0 ? usage.data.data.slice(0, 1).shift() : {};
      commit("SET_USAGE", data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getStatus({ state, commit, dispatch }, radiusServiceId) {
    try {
      let usage = await http.get(
        `visp/GetServiceStatusById/${radiusServiceId ||
          state.available.radiusServiceId}`
      );

      if (usage.data == null || usage.data == "")
        commit("SET_STATUS", {
          radiusServiceId: state.available.radiusServiceId,
          successfulAuth: false,
          lastLogTime: null
        });
      else commit("SET_STATUS", usage.data);
      return Promise.resolve(usage.data);
    } catch (e) {
      commit("SET_STATUS", {
        radiusServiceId: state.available.radiusServiceId,
        successfulAuth: false,
        lastLogTime: null
      });
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e, color: "error" },
        { root: true }
      );
      return Promise.resolve(e);
    }
  },
  async getServiceAccount({ commit, dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let account = await http.get(`visp/GetServiceAccount/${payload}`);
      commit("SET_SERVICE_ACCOUNT", account.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(account.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async updateService({ state, dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await http.post(`visp/UpdateService`, {
        userService: payload.service,
        restartSession: payload.restartSession,
        deleteStaticIp: payload.deleteStaticIp,
        ipGroup: payload.ipGroup,
        sellToUB: payload.service.sellToUB
      });

      let resultUpdateOption = await http.post(`visp/UpdateNbnOption`, {
        nbnOption: state.serviceDetails
      });

      if (result.data && resultUpdateOption.data) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: result.data.message, color: "success" },
          { root: true }
        );
      }

      dispatch("processLoader/setProcessInactive", {}, { root: true });

      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = e.response.data.description
        ? e.response.data.description
        : e.response.data ?? e.response.statusText;

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      return Promise.reject(e);
    }
  },
  async requestIPRange({ dispatch, rootState }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      await http.post(`visp/RequestStaticIPs/${rootState.auth.user}`, payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(true);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async requestIP({ dispatch, rootState, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let data = await http.post(`visp/RequestStaticIP`, {
        radiusServiceId: rootState.service.details.radiusServiceId,
        ipRange: payload
      });
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      commit("SET_IP", data.data);
      return Promise.resolve(data.data);
    } catch (e) {
      let message =
        e.response.data == "This service is not dynamic"
          ? "Static IP is already assigned to the service"
          : e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async removeIP({ dispatch, rootState, commit }, ipRange) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let payload = {
        radiusServiceId: rootState.service.details.radiusServiceId
      };
      if (ipRange != null && ipRange !== "") {
        payload.ipRange = ipRange;
      }
      let data = await http.post(`visp/DeleteStaticIP`, payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      commit("SET_IP", "");
      return Promise.resolve(data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getGroupList({ commit, dispatch, state }) {
    try {
      let groups = await http.get(
        `visp/GetStaticIps/${state.details.radiusServiceId}`
      );

      commit("SET_IP_GROUP", groups.data);
      return Promise.resolve(groups.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      return Promise.reject(e);
    }
  },
  async getGroupListForAccount({ commit, dispatch }, id) {
    try {
      let groups = await http.get(`visp/GetStaticIpsForAccount/${id}`);

      commit("SET_IP_GROUP", groups.data);
      return Promise.resolve(groups.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      return Promise.reject(e);
    }
  },
  async getRatePlans({ commit, dispatch }) {
    try {
      let rateplans = await http.get(`vonex/GetRatePlans`);
      let resultData = rateplans.data.length > 0 ? rateplans.data : [];
      commit(`SET_RATEPLANS`, resultData);
      return Promise.resolve(resultData);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      return Promise.reject(e);
    }
  },
  async uploadFile({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await http.post(`visp/ImportRundeck`, payload);
      if (result.status === 200) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: result.statusText, color: "success" },
          { root: true }
        );
      }
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async checkRadiusUsername({ dispatch }, radiusUsername) {
    try {
      let result = await http.post(
        `visp/CheckRadiusUsername/${radiusUsername}`
      );
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async addVispAccount({ dispatch }, account) {
    try {
      dispatch("processLoader/setProcessActive", {}, { root: true });
      let result = await http.post(`visp/AddVispAccount`, account);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.response.data, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getIpAddresses({ commit, dispatch }, search) {
    try {
      let address = await http.post(`visp/GetIpAddresses`, search);
      if (address && address.data && address.data.data) {
        commit("search/SET_ipAddress", address.data.data, {
          root: true
        });
        return Promise.resolve(address.data.data);
      }
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async importIpAddressesRange({ commit, dispatch }, subnet) {
    try {
      dispatch("processLoader/setProcessActive", {}, { root: true });
      let address = await http.post(`visp/ImportIpAddress`, subnet);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(address.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.response.data, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async addSingleIpAddresses({ commit, dispatch }, request) {
    try {
      dispatch("processLoader/setProcessActive", {}, { root: true });
      let address = await http.post(`visp/AddIpAddress`, request);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(address.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.response.data, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async releaseIpAddres({ commit, dispatch }, isImmediateRelease) {
    try {
      dispatch("processLoader/setProcessActive", {}, { root: true });
      let address = await http.post(
        `visp/ReleaseIpAddres/${isImmediateRelease}`
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(address.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async updateIpAddressState({ commit, dispatch }, request) {
    try {
      dispatch("processLoader/setProcessActive", {}, { root: true });
      let result = await http.post(`visp/UpdateIpAddressState`, request);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.response ? e.response.data : e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async switchProtocol({ dispatch, rootState, commit }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let data = await http.post(`visp/SwitchProtocol`, {
        radiusServiceId: rootState.service.details.radiusServiceId
      });
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(data.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  }
};
